import { FC, MouseEvent, useCallback, useState } from 'react'

import * as S from './ConfirmActionFooter.styles'
import { ConfirmActionFooterProps } from './ConfirmActionFooter.types'
import { ConfirmActionFooterContent } from './ConfirmActionFooterContent'

export const ConfirmActionFooter: FC<ConfirmActionFooterProps> = ({
  title,
  message,
  onConfirm,
  onClick = () => null,
  onToggleMessage,
  children,
  theme,
  cancelText,
  confirmText,
  confirmButtonType,
  shouldCloseOnSubmit = true,
  isActionLoading,
}) => {
  const [shouldDisplayActionContainer, setShouldDisplayActionContainer] = useState(false)

  const handleHideMessage = useCallback(() => {
    setShouldDisplayActionContainer(false)
    if (onToggleMessage) {
      onToggleMessage(false)
    }
  }, [onToggleMessage])

  const handleShouldDisplayActionContainer = useCallback(() => {
    setShouldDisplayActionContainer(true)
    if (onToggleMessage) {
      onToggleMessage(true)
    }
  }, [onToggleMessage])

  const handleOnActionConfirmed = useCallback(() => {
    if (!isActionLoading) {
      onConfirm?.()
      if (shouldCloseOnSubmit) {
        handleHideMessage()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onConfirm, isActionLoading, shouldCloseOnSubmit])

  const handleOnClickAction = useCallback(
    (e: MouseEvent<HTMLDivElement>) => {
      onClick(e)
      handleShouldDisplayActionContainer()
    },
    [handleShouldDisplayActionContainer, onClick],
  )

  return (
    <>
      <S.ChildrenContainer onClick={handleOnClickAction}>{children}</S.ChildrenContainer>
      <ConfirmActionFooterContent
        cancelText={cancelText}
        confirmButtonType={confirmButtonType}
        confirmText={confirmText}
        message={message}
        onCancel={handleHideMessage}
        onConfirm={handleOnActionConfirmed}
        title={title}
        theme={theme}
        isActionLoading={isActionLoading}
        shouldDisplayActionContainer={shouldDisplayActionContainer}
      />
    </>
  )
}
